// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"1ad3a56b","15":"c503cc69","38":"2271f003","75":"26b229d8","197":"da416692","242":"e882355d","381":"daeb9a18","404":"f96be79f","630":"57b597bf","723":"2bf91027","801":"d7aad190","958":"39f7fd9e"}[chunkId] + ".chunk.js";
};